module.exports = function () {
    if ( document.querySelector(".reading-progress-bar") && document.querySelector(".main-content") ) {
        const progressBar = document.querySelector(".reading-progress-bar");
        
        // update progress bar
        const updateProgressBar = () => {
            const result = ( document.documentElement.scrollTop / document.querySelector(".main-content").getBoundingClientRect().height ) * 100
            progressBar.style.width = `${result}%`;
        }

        updateProgressBar();
        window.addEventListener("scroll", updateProgressBar)
        
        // update progress bar position
        if ( document.getElementById("site-header") ) {
            const header = document.getElementById("site-header");
            
            const updateProgressBarPosition = () => {
                progressBar.style.top = header.getBoundingClientRect().height + "px";
            }

            updateProgressBarPosition();
            window.addEventListener("resize", updateProgressBarPosition)
        }
    }
}